<template>
  <q-card class="tm-card">
    <slot />
  </q-card>
</template>
